import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, Checkbox } from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import { loadHiddenColumns, saveHiddenColumns } from "./viewFiltersApi";

const LOCKED_ACCESSORS = ['actions'];

const ViewFiltersModal = (props) => {
    const { open, close, moduleName, availableColumns, onSaved } = props;
    const togglableColumns = (availableColumns || []).filter(c => LOCKED_ACCESSORS.indexOf(c.accessor) === -1);
    const [hidden, setHidden] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open) return;
        let cancelled = false;
        setError("");
        setLoading(true);
        loadHiddenColumns(moduleName).then((arr) => {
            if (cancelled) return;
            const sanitized = Array.isArray(arr) ? arr.filter(a => LOCKED_ACCESSORS.indexOf(a) === -1) : [];
            setHidden(sanitized);
            setLoading(false);
        });
        return () => { cancelled = true; };
    }, [open, moduleName]);

    const toggle = (accessor) => {
        if (hidden.indexOf(accessor) === -1) {
            setHidden([...hidden, accessor]);
        } else {
            setHidden(hidden.filter((a) => a !== accessor));
        }
    };

    const showAll = () => setHidden([]);

    const save = async () => {
        setSaving(true);
        setError("");
        const result = await saveHiddenColumns(moduleName, hidden);
        setSaving(false);
        if (result.ok) {
            if (typeof onSaved === "function") onSaved(hidden);
            close();
        } else {
            setError("Failed to save. Please try again.");
        }
    };

    return (
        <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm">
            <DialogTitle>
                <div style={{ textAlign: "center", fontWeight: "bold" }}>View Filters</div>
            </DialogTitle>
            <div style={{ padding: 20 }}>

                <div style={{ marginBottom: 10 }}>
                    <Button size="sm" color="white" onClick={showAll}>Show all</Button>
                </div>
                {loading && <div>Loading...</div>}
                {!loading && (
                    <div style={{ maxHeight: 360, overflowY: "auto", border: "1px solid #eee", padding: 8 }}>
                        {togglableColumns.map((c) => {
                            const isHidden = hidden.indexOf(c.accessor) !== -1;
                            return (
                                <div key={c.accessor} style={{ display: "flex", alignItems: "center" }}>
                                    <Checkbox
                                        checked={!isHidden}
                                        onChange={() => toggle(c.accessor)}
                                    />
                                    <span>{c.Header || c.accessor}</span>
                                </div>
                            );
                        })}
                    </div>
                )}
                {error && <div style={{ color: "#da2229", marginTop: 8, fontSize: 12 }}>{error}</div>}
                <div style={{ marginTop: 16, display: "flex", gap: 12, justifyContent: "flex-end" }}>
                    <Button color="white" onClick={close} disabled={saving}>Cancel</Button>
                    <Button color="primary" onClick={save} disabled={saving || loading}>
                        {saving ? "Saving..." : "Save"}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default ViewFiltersModal;
